var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.CYCLIC_TERM_UPDATE_TYPE = {
    THIS: 'THIS',
    THIS_AND_UPCOMING: 'THIS_AND_UPCOMING',
    ALL: 'ALL'
};

Object.freeze(Enum.MEEDY.CYCLIC_TERM_UPDATE_TYPE);